<template>
  <scroller
    @change="handleScrollerChange"
    tag="section"
  >
    <div
      class="foreground"
      slot="foreground"
      :class="{'dh-body__part': true, [this.theme]: true }"
    >
      <div
        v-for="(item, idx) in this.part[1]"
        :key="idx"
        :class="['dh-body__part-section', {
          'dh-body__part-section--active': currentIndex >= idx,
          [`dh-body__part-section--${item.type}`]: true
        }]"
      >
        <Paragraph
          v-if="item.type === 'paragraph'"
          :content={item}
        />
        <Paragraph
          v-else-if="item.type === 'ingress'"
          :content={item}
          :isIngress="true"
        />
        <Paragraph
          v-else-if="item.type === 'lead'"
          :content={item}
          :isLead="true"
        />
        <Extract
          v-else-if="item.type === 'extract'"
          :content='item.value.content'
          :id="item.value.id"
          :text="item.value.text"
          :author="item.value.author"
        />
        <JournalSeries
          v-else-if="item.type === 'journal-series'"
          :item="item"
        />
        <!--<Journal v-else-if="item.type === 'journal'" :content='item.value.content' :title='item.value.title' :date='item.value.date' :align='item.value.align' />-->
        <!--<Diary v-else-if="item.type === 'diary'" :content='item.value.content' :title='item.value.title' :date='item.value.date' :align='item.value.align' />-->
        <Highlight
          v-else-if="item.type === 'highlight'"
          :heading="item.value.heading"
          :content='item.value.content'
          :type="item.value.type"
          :currentIndex='currentIndex'
          :idx='idx'
        />
        <Heading
          :level='2'
          v-else-if="item.type === 'title'"
          :content='item.value'
        />
        <Chapter
          v-else-if="item.type === 'chapter'"
          :item="item"
        />
        <Heading
          :level='3'
          v-else-if="item.type === 'subtitle'"
          :content='item.value'
        />
        <ScrollVoiceText
          v-else-if="item.type === 'sound'"
          :soundId="item.value['sound-id']"
          :imageId="item.value['image-id']"
          :isIntro="false"
          :callToAction="item.value['call-to-action']"
        />
        <RegularImage
          v-else-if="item.type === 'image'"
          :imageId="item.value['id']"
          :inline="!!item.value['inline']"
          :aspect="item.value['aspect'] || 'F169'"
        />
        <VideoLoop
          v-else-if="item.type === 'video'"
          :active="currentIndex >= idx"
        />
        <Slider
          v-else-if="item.type === 'slider'"
          :active="currentIndex >= idx"
          :image-ids="item.value.imageIds"
        />
        <DataViz
          v-else-if="item.type === 'data-viz'"
          :active="currentIndex >= idx"
          :item="item"
        />
        <DataVizSeries
          v-else-if="item.type === 'data-viz-series'"
          :active="currentIndex >= idx"
          :item="item"
        />
        <List
          v-else-if="item.type === 'list'"
          :active="currentIndex >= idx"
          :item="item"
        />
        <Example
          v-else-if="item.type === 'example'"
          :active="currentIndex >= idx"
          :item="item.value"
        />
        <Logo
          v-else-if="item.type === 'logo'"
          :active="currentIndex >= idx"
          :type="item.value"
        />
        <VHXL
          v-else-if="item.type === 'VHXL'"
          :active="currentIndex >= idx"
          :id="item.value"
        />
        <p
          v-else-if="item.type === 'comment'"
          style="color: #999; text-align: center; font-style: italic"
        >Kommentar: {{ item.value }}</p>
        <p v-else-if="item.type !== 'theme'">{{ JSON.stringify(item, null, 2) }}</p>
      </div>
    </div>
  </scroller>
</template>

<script>
import Paragraph from '../Typography/Paragraph.vue'
import Heading from '../Typography/Heading.vue'
import Chapter from '../Typography/Chapter.vue'
import List from '../Typography/List.vue'
import Extract from '../Sections/Extract/index.vue'
import JournalSeries from '../Sections/JournalSeries/index.vue'
import Example from '../Sections/Example/index.vue'
import Highlight from '../Sections/Highlight/index.vue'
import VHXL from '../Sections/VHXL/index.vue'
import ScrollVoiceText from '../Media/Audio/ScrollVoiceText.vue'
import RegularImage from '../Media/Images/Regular.vue'
import VideoLoop from '../Media/Video/VideoLoop.vue'
import Scroller from '../Utilities/Scroller.vue'
import Slider from '../Media/Images/Slider.vue'
import DataViz from '../Media/Graphs/index.vue'
import DataVizSeries from '../Media/Graphs/series.vue'
import Logo from '../Widgets/Logo.vue'
import globalEventStore from '../../lib/global-event-store'

export default {
  data: () => ({
    currentIndex: -1
  }),
  props: ['part', 'idx'],
  computed: {
    theme() {
      const theme = this.part[1].find(({ type }) => type === 'theme')
      return theme ? `dh-body__part--${theme.value}` : null
    }
  },
  methods: {
    handleScrollerChange(e) {
      try {
        if (e !== -1) {
          globalEventStore.dispatch(this.$root.$data.id, 'sendGaEvent', {
            action: `CHANGE_ACTIVE_SECTION/${this.idx}/${e}`
          })
        }
        this.currentIndex = e
      } catch (err) {
        console.error('here', err)
      }
    }
  },
  components: {
    Paragraph,
    Heading,
    Extract,
    JournalSeries,
    Chapter,
    List,
    Logo,
    Example,
    Highlight,
    ScrollVoiceText,
    RegularImage,
    VideoLoop,
    Scroller,
    Slider,
    DataViz,
    DataVizSeries,
    VHXL
  }
}
</script>

<style lang="postcss" scoped>
  .dh-body__part {
    margin: -50px 0;
    padding: 50px 0;

    &:first-of-type {
      margin: 0;
      padding: 0 0 50px;
    }
  }

  .dh-body__part--dark {
    color: #fff;
    background-color: #141516;
  }

  .dh-body__part-section {
  }

  .dh-body__part-section--sound {
    margin: 50px 0;
  }

  .dh-body__part-section--active {
    opacity: 1;
  }

  .dh-body__part-section--no-overflow {
    overflow: hidden;
  }

  .dh-psy-visible {
    opacity: 1;
  }

  .dh-body__part-section.article-feature {
    padding: 0 18px;
  }
  .dh-body__part-section.article-feature > * {
    padding: 0;
    float: none;
  }

  .dh-body__part-section--subtitle {
    margin-top: 100px;

    @media (min-width: 800px) {
      margin-top: 150px;
    }
  }
</style>
